const Loader = () => {
  return (
    <div
      className="loading-page"
      style={{ display: "flex", flexDirection: "column", gap: "10px" }}
    >
      <div className="spinner"></div>
      <span>Loading...</span>
    </div>
  );
};

export default Loader;

// const Loader = () => {
//   return (
//     <div className="loading-page">
//       <div className="loading-wrapper">
//         <svg
//           className="loader12"
//           height="57"
//           width="57"
//           viewBox="0 0 57 57"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <g fill="none" fillRule="evenodd">
//             <g strokeWidth="2" transform="translate(1 1)">
//               <circle className="dot dot-left" cx="5" cy="50" r="5" />
//               <circle className="dot dot-top" cx="27" cy="5" r="5" />
//               <circle className="dot dot-right" cx="50" cy="50" r="5" />
//             </g>
//           </g>
//         </svg>
//       </div>
//     </div>
//   );
// };

// export default Loader;
